import React, { useState, useRef } from "react";
import { Icon, Dropdown } from "semantic-ui-react";
import html2canvas from "html2canvas";
import moment from "moment";
import { kFormatter } from "../../../../../Dashboard/Charts/utils";
import NoData from "../../../../../Dashboard/Charts/NoData/NoData";
import DimmerComponent from "../../../../../Dashboard/DimmerComponent";
import { downloadCSVData, downloadCanvasWithTitle } from "../../../../../Dashboard/Charts/utils";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import FBPageSelector from "../../../../../FbInsights/FBPageSelector";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as DownloadIcon } from "../../../../../../../assets/svg/downloads.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import TwitterPageSelector from "../TwitterPageSelector";
import "./TotalValueCharts.scss";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

function TotalFollowers(props) {
    const [downloading, setDownloading] = useState(false);
    const chartEl = useRef();
    let nodata = props.pageStatus || !props.data;

    let current = props.data?.current?.followers_count;
    let previous = props.data?.previous?.followers_count;

    const increment = () => {
        if (props.twitterPageList.length === 1) return;
        let index;
        props.twitterPageList.map((value, ind) => {
            if (value.value === props.selectedTwitterPage.value) index = ind;
        });
        if (index === props.twitterPageList.length - 1) props.setSelectedTwitterPage(props.twitterPageList[0]);
        else props.setSelectedTwitterPage(props.twitterPageList[index + 1]);
    };

    const decrement = () => {
        if (props.twitterPageList.length === 1) return;
        let index;
        props.twitterPageList.map((value, ind) => {
            if (value.value === props.selectedTwitterPage.value) index = ind;
        });
        if (index === 0) props.setSelectedTwitterPage(props.twitterPageList[props.twitterPageList.length - 1]);
        else props.setSelectedTwitterPage(props.twitterPageList[index - 1]);
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName isTwitter isTWPage={props.isTWPage} name={props.widget?.name || "Total Followers"} info="Total number of Followers of Your Page" />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isTWPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget?.name}
                            />
                        )}
                    {/* {!props.isPublic && !props.isResearchDashboard && <>{renderDownloadButton(nodata)}</>} */}
                    {
                        <>
                            {(props.isPublic && nodata) || props.isTWPage ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expand ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }

                    {!props.isPublic && !props.isTWPage && (
                        <MoreOptions data-html2canvas-ignore="true" className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />
                    )}
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!props.isTWPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                            </>
                        )}
                    {!props.isTWPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && <DeleteWidget onClick={props.deleteWidget} />}
                </ChartOptionsSidebar>
            )}
            {!nodata ? (
                <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chartEl}>
                    {!props.isTWPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-left ${props.twitterPageList?.length === 1 ? "disabled" : ""}`}
                            onClick={decrement}>
                            <ArrowIcon />
                        </div>
                    )}
                    <div className="chart-area">
                        {!props.isTWPage && props.selectedTwitterPage && (
                            <TwitterPageSelector
                                selectedTwitterPage={props.selectedTwitterPage}
                                setSelectedTwitterPage={props.setSelectedTwitterPage}
                                twitterPageList={props.twitterPageList}
                                widgetContainerRef={props.widgetContainerRef}
                            />
                        )}
                        <div className="totalValueCharts">
                            <div className="currentPeriod">
                                <p className="row-1">{kFormatter(current)}</p>
                                <p className="row-2">Total Followers</p>
                            </div>
                            <div className="previousPeriod">
                                {current > previous ? (
                                    <p className="positivePercentageChange">+{(((current - previous) / previous) * 100).toFixed(2)}%</p>
                                ) : current === previous ? null : (
                                    <p className="negativePercentageChange">-{(((previous - current) / previous) * 100).toFixed(2)}%</p>
                                )}
                            </div>
                        </div>
                    </div>
                    {!props.isTWPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-right ${props.twitterPageList?.length === 1 ? "disabled" : ""}`}
                            onClick={increment}>
                            <ArrowIcon />
                        </div>
                    )}
                </div>
            ) : (
                <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
            )}
            {(props.loading || !props.selectedTwitterPage) && <DimmerComponent />}
        </>
    );

    return props.isTWPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}

export default TotalFollowers;
